import { AdobeAnalyticsUtil } from '/Foundation/Common/code/Views/Foundation/Common/AdobeAnalytics/AdobeAnalyticsUtil';
import { analyticsForAdd, analyticsForRemove } from '/Foundation/Common/code/Helpers/TrackingHelper';

export const getEventMap = () => {
  return {
    'GA/ADD': add,
    'GA/REMOVE': remove,
  };
};

const add = (action) => {
  return analyticsForAdd(action);
};

const remove = (action) => {
  return analyticsForRemove(action);
};

export const trackCartView = () => {
  if (!window.adobeDataLayer) return;

  let previousTitle = window.adobeDataLayer.page.title;

  // Switching and switching back without delay causes the event to trigger with the wrong title
  setTimeout(() => {
    window.adobeDataLayer.page.title = 'Cart';
    AdobeAnalyticsUtil.DataLayer.TrackEvent('pageview');
  }, 50);

  window.adobeDataLayer.page.title = previousTitle;
};
